import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-message",
  "use": "icon-message-usage",
  "viewBox": "-2 -2 28 28",
  "content": "<symbol viewBox=\"-2 -2 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-message\"><path d=\"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z\" fill=\"white\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol